import { Pipe, PipeTransform } from '@angular/core';
import { transformPrice } from '@app/core/price-utils';
import { AmountPrice } from '@app/sales/models/price.model';
import { EquipmentPrice } from '@app/sales/modules/mobilephone/models/equipment-upgrade-agreement.model';
import { Price } from '@shared/models/price.model';

@Pipe({
  name: 'priceFormat',
  standalone: true,
})
export class PriceFormatPipe implements PipeTransform {
  transform(
    price: AmountPrice | Price | number | EquipmentPrice | undefined,
    priceType: PriceType,
    priceIsZeroText?: string
  ): string {
    return transformPrice(price, priceType, priceIsZeroText);
  }
}

export enum PriceType {
  Monthly = 'Monthly',
  OneTime = 'OneTime',
}
